import { Box, Paper, Stack, Typography } from '@mui/material'

export function StepWelcome() {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        bgcolor: '#ffffff',
        p: { xs: 3, sm: 4, lg: 5 },
        boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
      }}
    >
      <Stack spacing={2.5} sx={{ maxWidth: 768, fontSize: { xs: 14, sm: 16 }, lineHeight: 1.625, color: '#1e293b' }}>
        <Typography sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
          We are pleased to welcome you as a partner and appreciate your trust in MISC to manage
          your Surplus Lines Tax Filings!
        </Typography>
        <Typography sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
          You now have a team of experts behind you – people who genuinely care about accuracy,
          timelines, and making your life easier:
        </Typography>
        <Box>
          <Typography sx={{ fontWeight: 500, color: '#0f172a', fontSize: 'inherit', lineHeight: 'inherit' }}>
            Here&apos;s what happens next:
          </Typography>
          <Box
            component="ul"
            sx={{ mt: 1.5, pl: 2.5, m: 0, listStyleType: 'disc' }}
          >
            <Box component="li" sx={{ mb: 1 }}>
              Onboarding instructions with a video will be provided that will guide you through
              each step
            </Box>
            <Box component="li" sx={{ mb: 1 }}>
              We&apos;ll provide a checklist of the documents and information required to get you set
              up in our system
            </Box>
            <Box component="li">You&apos;ll get access to our tools, resources, and support team</Box>
          </Box>
        </Box>
        <Typography sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
          We&apos;re here to make compliance simple, predictable, and stress-free.
        </Typography>
        <Typography sx={{ fontWeight: 500, color: '#0f172a', fontSize: 'inherit', lineHeight: 'inherit' }}>
          Welcome – we&apos;re excited to get started with you.
        </Typography>
      </Stack>
    </Paper>
  )
}
